import React from 'react'
import Hero from '../Hero'
import { Header1 } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'
import { HeroOverride } from './styles'
import HeroImage from '../../../public/how-it-works/how_it_works_banner.webp'

const HeroContent = () => (
  <>
    <Header1 align="center">
      {'FIVE-STAR\nBEAUTY\nSERVICES\nAT YOUR\nDOOR'}
    </Header1>
    <Button color={c.cobalt} path="/book" large padding="14px 80px" margin="40px 0 0 0">
      Book Glam
    </Button>
  </>
)

const Header = () => (
  <HeroOverride>
    <Hero
      image={HeroImage}
      content={<HeroContent />}
      header="Five-star beauty services at your door"
      hideCTA
    />
  </HeroOverride>
)

export default Header
